import React, { useState } from "react";
import DeviceTabAdmin from "./DeviceTabAdmin";
import ModuleTabAdmin from "./ModuleTabAdmin";
import CompanyDetailsAdmin from "./CompanyDetailsAdmin";
// import DepartmentTab from "./DepartmentTab";


const tabList = ["Devices", "Modules", "Details", "Department"];

const CompanyTabAdmin = (props) => {

  const {setShowComponent,company_details, updateCompanyDetailsAfterSaving} = props

  const [activeTab, setActiveTab] = useState("Devices");

  const renderContent = () => {
    switch (activeTab) {
      case "Devices":
        return <DeviceTabAdmin company_details={company_details} setShowComponent={setShowComponent}/>;
      // case "Modules":
      //   return <ModuleTabAdmin company_details={company_details}/>;
      // case "Details":
      //   return <CompanyDetailsAdmin company_details={company_details} updateCompanyDetailsAfterSaving={updateCompanyDetailsAfterSaving}/>;
      // case "API":
      //   return <ApiTabAdmin/>; 
      // case "Department":
      //   return <DepartmentTab/>;
      default:
        return null;
    }
  };

  return (
    <div className="w-full  mx-auto mt-6 bg-white shadow rounded">
      <div className="border-b border-gray-200 flex">
        {tabList.map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-6 py-3 text-sm font-medium ${
              activeTab === tab
                ? "border-b-2 border-blue-600 text-blue-600"
                : "text-gray-500 hover:text-blue-500"
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="bg-gray-50">{renderContent()}</div>
    </div>
  );
};

export default CompanyTabAdmin;
